import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";

export const eventSignBeam = createBeam(bifrost, "/game/event/sign", {
    depth:1,
    unfold:"result",
});
